<template>
    <section class="section">
        <div class="container">
            <div class="columns">
                <div class="column is-4-desktop is-offset-4-desktop">
                    <h1 class="title">Create new user</h1>
                    <transition name="fade">
                        <div v-if="success" class="notification is-warning has-text-centered">
                            User successfully created!
                        </div>
                    </transition>
                    <form>
                        <div class="field">
                            <div class="control has-icons-left">
                                <input v-model="user.name"
                                       v-bind:class="{ 'is-danger': error.errors.name }"
                                       class="input"
                                       type="text"
                                       placeholder="Full name">
                                <span class="icon is-small is-left">
                                    <i class="fas fa-user"></i>
                                </span>
                                <p v-if="error.errors.name" class="help is-danger">{{ error.errors.name[0] }}</p>
                            </div>
                        </div>
                        <div class="field">
                            <div class="control has-icons-left">
                                <input v-model="user.email"
                                       v-bind:class="{ 'is-danger': error.errors.email }"
                                       class="input"
                                       type="email"
                                       placeholder="Email"
                                       required=""
                                       autofocus="">
                                <span class="icon is-small is-left">
                                    <i class="fas fa-envelope"></i>
                                </span>
                                <p v-if="error.errors.email" class="help is-danger">{{ error.errors.email[0] }}</p>
                            </div>
                        </div>
                        <div class="field">
                            <div class="control has-icons-left">
                                <input v-model="user.phone"
                                       v-bind:class="{ 'is-danger': error.errors.phone }"
                                       class="input"
                                       type="number"
                                       placeholder="Phone"
                                       required=""
                                       autofocus="">
                                <span class="icon is-left">
                                    <i class="fas fa-phone"></i>
                                </span>
                                <p v-if="error.errors.phone" class="help is-danger">{{ error.errors.phone[0] }}</p>
                            </div>
                        </div>
                        <div class="field">
                            <div class="control has-icons-left">
                                <input v-model="user.password"
                                       v-bind:class="{ 'is-danger': error.errors.password }"
                                       class="input"
                                       type="password"
                                       placeholder="Password">
                                <span class="icon is-small is-left">
                                  <i class="fas fa-lock"></i>
                                </span>
                                <p v-if="error.errors.password" class="help is-danger">{{ error.errors.password[0] }}</p>
                            </div>
                        </div>
                        <div class="field">
                            <div class="control has-icons-left">
                                <input v-model="user.password_confirmation"
                                       v-bind:class="{ 'is-danger': error.errors.password_confirmation }"
                                       class="input"
                                       type="password"
                                       required=""
                                       placeholder="Confirm Password">
                                <span class="icon is-small is-left">
                                  <i class="fas fa-lock"></i>
                                </span>
                                <p v-if="error.errors.password_confirmation" class="help is-danger">{{ error.errors.password_confirmation[0] }}</p>
                            </div>
                        </div>
                        <div class="field">
                            <div class="control has-icons-left">
                                <div class="select is-fullwidth">
                                    <select v-model="user.type" v-on:change="userType(user.type)" v-bind:class="{ 'is-danger': error.errors.type }">
                                        <option :value="this.$userTypeIndividual">Individual</option>
                                        <option :value="this.$userTypeProfessional">Professional</option>
                                        <option :value="this.$userTypeOther">Other</option>
                                    </select>
                                </div>
                                <span class="icon is-left">
                                    <i class="fas fa-user"></i>
                                </span>
                                <p v-if="error.errors.type" class="help is-danger">{{ error.errors.type[0] }}</p>
                            </div>
                        </div>
                        <div v-if="isProfessional" class="field">
                            <div class="control">
                                <input v-model="user.company"
                                       v-bind:class="{ 'is-danger': error.errors.company }"
                                       class="input"
                                       type="text"
                                       required=""
                                       placeholder="Company name">
                                <p v-if="error.errors.company" class="help is-danger">{{ error.errors.company[0] }}</p>
                            </div>
                        </div>
                        <div class="field">
                            <div class="control has-icons-left">
                                <div class="select is-fullwidth" v-bind:class="{ 'is-danger': error.errors.country }">
                                    <select v-model="user.country">
                                        <option value="" hidden disabled>Country</option>
                                        <option v-for="country in countries">{{ country.name }}</option>
                                    </select>
                                </div>
                                <span class="icon is-left">
                                        <i class="fas fa-globe"></i>
                                    </span>
                                <p v-if="error.errors.country" class="help is-danger">{{ error.errors.country[0] }}</p>
                            </div>
                        </div>
                        <div class="field">
                            <div class="control has-icons-left">
                                <div class="select is-fullwidth">
                                    <select v-model="user.role">
                                        <option selected value="">Select user role</option>
                                        <option v-for="role in roles" :value="role">{{ role }}</option>
                                    </select>
                                </div>
                                <span class="icon is-left">
                                    <i class="fas fa-user-shield"></i>
                                </span>
                            </div>
                        </div>
                        <div class="field">
                            <div class="control">
                                <a @click.prevent="register" class="button is-primary is-fullwidth">Register</a>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import apiUsers from '../../api/apiUsers'
    import axios from 'axios'
    export default {
        data() {
            return {
                countries: [],
                professional: false,
                roles: [
                    'Visitor',
                    'User',
                    'Manager',
                    'Affiliate',
                    'Admin'
                ],
                user: {
                    name: '',
                    email: '',
                    phone: '',
                    type: this.$userTypeIndividual,
                    company: '',
                    country: '',
                    password: '',
                    password_confirmation: '',
                    role: ''
                },
                error: {
                    message: '',
                    errors: {
                        name: '',
                        email: '',
                        phone: '',
                        type: '',
                        company: '',
                        country: '',
                        password: '',
                        password_confirmation: ''
                    }
                },
                success: false
            }
        },
        computed: {
            isProfessional () {
                return this.professional
            }
        },
        methods: {
            userType(type) {
                this.professional = type === this.$userTypeProfessional;

            },
            register() {
                this.clearAllErrors()
                apiUsers
                    .signUpRequestByAdmin(this.user)
                    .then((response) => {
                        if ( response.status === 201 ) {
                            this.clearFields()
                            this.success = true;
                            setTimeout(() => {
                                this.success = false;
                            }, 5000)
                        }
                    })
                    .catch((err) => {
                        if ( err.response && err.response.status === 422 ) {
                            this.error.message = err.response.statusText
                            this.error.errors = err.response.data.errors
                        } else {
                            this.error.message = 'Connection error!'
                        }
                    })
            },
            clearAllErrors() {
                this.error = {
                    message: '',
                    errors: {
                        name: '',
                        email: '',
                        phone: '',
                        type: '',
                        company: '',
                        country: '',
                        password: '',
                        password_confirmation: ''
                    }
                }
            },
            clearFields() {
                this.user = {
                    name: '',
                    email: '',
                    phone: '',
                    type: this.$userTypeIndividual,
                    company: '',
                    country: '',
                    password: '',
                    password_confirmation: '',
                    role: ''
                }
            }
        },
        mounted () {
            axios.get('https://restcountries.com/v3.1/all?fields=name')
                .then((response) => {
                    this.countries = response.data
                })
        }
    }
</script>

<style scoped>
    .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/Users/UserCreate.vue